const guia_de_transferencias = {
  path: "/guia-de-transferencias",
  redirect: "/guia-de-transferencias",
  meta: {
    breadCrumb: "Processo de Matrículas - Confirmar a Transferência do Aluno",
  },
  children: [
    {
      path: "/guia-de-transferencias",
      name: "guia_de_transferencias",
      component: () =>
        import("@/views/GuiaDeTransferencias/GuiaDeTransferenciasHome.vue"),
    },
  ],
};

export { guia_de_transferencias };
